import { useState } from "react";
import PropTypes from 'prop-types';
import { treeFactory } from "../../common/TreeFactory/TreeFactory";
import { Icon } from "../Icon/Icon";
import { Modal } from "../Modal/Modal";
import { Button } from "../Button/Button";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
(function () {
  if (typeof document === "undefined") {
    return;
  }
  const styles = ".kof-tree ul {\n  list-style: none;\n}\n.kof-tree > ul {\n  padding-left: 0;\n}\n.kof-tree > ul ul {\n  padding-left: 1em;\n}\n.kof-tree.crud .add {\n  margin-bottom: 8px;\n}\n.kof-tree.crud li .row {\n  display: flex;\n  padding: 2px 0;\n  border-bottom: 1px solid lightgrey;\n  align-items: center;\n  justify-content: space-between;\n}\n.kof-tree.crud li .row label:hover {\n  cursor: pointer;\n}\n.kof-tree.crud li .row .actions {\n  display: flex;\n  align-items: center;\n}\n.kof-tree.crud li .row .actions svg {\n  padding: 2px;\n}";
  const fileName = "Tree_Tree_ea8f730b-77eb-46c4-ab47-e6025782b47f";
  const element = document.querySelector("style[data-sass-component='Tree_Tree_ea8f730b-77eb-46c4-ab47-e6025782b47f']");
  if (!element) {
    const styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
const Tree = props => {
  const [removingItem, setRemovingItem] = useState(null);
  const canAdd = props.actions && props.actions.onClickAdd;
  const canChange = props.actions && props.actions.onClickChange;
  const canMoveUp = props.actions && props.actions.onClickMoveUp;
  const canMoveDown = props.actions && props.actions.onClickMoveDown;
  const canRemove = props.actions && props.actions.onSubmitRemoval;
  const tree = treeFactory.create(props.items, props.rootItemId);
  const renderTree = tree => {
    if (!tree.length) {
      return;
    }
    return /*#__PURE__*/_jsx("ul", {
      children: tree.map((item, index) => {
        const currentSequence = index + 1;
        return /*#__PURE__*/_jsxs("li", {
          className: item.class,
          children: [/*#__PURE__*/_jsxs("div", {
            className: 'row',
            children: [/*#__PURE__*/_jsx("label", {
              onClick: canChange ? () => props.actions.onClickChange(item) : null,
              children: item.label
            }), props.actions && /*#__PURE__*/_jsxs("div", {
              className: 'actions',
              children: [canMoveUp && /*#__PURE__*/_jsx(Icon, {
                type: 'up',
                onClick: () => props.actions.onClickMoveUp(item, currentSequence)
              }), canMoveDown && /*#__PURE__*/_jsx(Icon, {
                type: 'down',
                onClick: () => props.actions.onClickMoveDown(item, currentSequence)
              }), canChange && /*#__PURE__*/_jsx(Icon, {
                type: 'change',
                onClick: () => props.actions.onClickChange(item)
              }), canRemove && /*#__PURE__*/_jsx(Icon, {
                type: 'remove-trash',
                onClick: () => setRemovingItem(item)
              })]
            })]
          }), renderTree(item.children)]
        }, item.id);
      })
    });
  };
  const onSubmitRemoval = () => {
    setRemovingItem(null);
    props.actions.onSubmitRemoval(removingItem);
  };
  const classes = ['kof-tree', props.actions ? 'crud' : null];
  return /*#__PURE__*/_jsxs("div", {
    className: classes.join(' '),
    children: [canAdd && /*#__PURE__*/_jsx("div", {
      className: 'add',
      children: /*#__PURE__*/_jsx(Icon, {
        type: 'add',
        onClick: props.actions.onClickAdd
      })
    }), renderTree(tree), canRemove && removingItem && /*#__PURE__*/_jsxs(Modal, {
      isOpen: true,
      onClose: () => setRemovingItem(null),
      children: [/*#__PURE__*/_jsx("p", {
        children: props.translate('crud.remove.are-you-sure', {
          name: removingItem.label
        })
      }), /*#__PURE__*/_jsx(Button, {
        onClick: onSubmitRemoval,
        children: props.translate('crud.remove')
      })]
    })]
  });
};
Tree.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    // label can be a link component, maybe rename to rowContent?
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
    parentId: PropTypes.string
  })).isRequired,
  actions: PropTypes.shape({
    onClickAdd: PropTypes.func,
    onClickChange: PropTypes.func,
    onClickMoveUp: PropTypes.func,
    onClickMoveDown: PropTypes.func,
    onSubmitRemoval: PropTypes.func
  }),
  translate: PropTypes.func,
  rootItemId: PropTypes.string
};
export { Tree };